'use strict';

function dropdownHeaderDirective () {

  function link (scope, el, attrs, ctrl) {

    el.on('click', function (e) {
      scope.$evalAsync(function () {
        ctrl.toggleVisibility(e);
      });

      // stop event from propogating up to window.document because we have a listener attached
      // to the document that will close all the open dropdowns
      e.stopPropagation();
    });
  }

  return {
    link: link,
    require: '^sbDropdown',
    template: '<div class="dropdown-header" ng-transclude></div>',
    transclude: true
  };
}

module.exports = dropdownHeaderDirective;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/dropdown/src/dropdownHeader/DropdownHeaderDirective.js